module.exports = __webpack_public_path__ + "img/backHome_04.9be16206.png";